import { create } from 'zustand';

let hideTimer = null;

const useToastStore = create((set) => ({
  message: '',
  visible: false,
  show: (message) => {
    set({ message, visible: true });
    clearTimeout(hideTimer);
    hideTimer = setTimeout(() => set({ visible: false }), 2600);
  },
}));

/* Imperative helper so stores/handlers can toast without a hook. */
export const showToast = (message) => useToastStore.getState().show(message);

export default useToastStore;
